var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunctions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 842.18,
    y1: 45.8014,
    x2: 870.17,
    y2: 73.7913,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad",
    id: "fill0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73B4C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1747,
    stopColor: "#6AAEC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4567,
    stopColor: "#529EB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#2C839F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#147391"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-833 -31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M866.499 54.151 862.545 48 855.103 48 862.288 58.5 855.103 69 862.545 69 866.499 62.849 870.453 69 877.85 69 870.71 58.502 877.895 48 870.453 48Z",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.6 36.677C851.349 36.677 849.444 37.343 847.939 38.656 846.436 39.967 845.519 41.746 845.215 43.943L844.779 48 841.999 48 841.999 54 843.864 54 842.36 63.535C841.933 66.365 841.093 67.797 839.863 67.797 839.317 67.797 838.858 67.692 838.498 67.485L836.999 66.62 836.999 73 837.765 73.213 837.908 73.247C838.198 73.317 838.497 73.389 838.802 73.464 839.24 73.571 839.678 73.625 840.107 73.625 842.459 73.625 844.437 72.754 845.986 71.036 847.471 69.387 848.437 67.094 848.857 64.22L850.45 54 853.999 54 853.999 48 851.361 48 851.776 44.48C851.883 43.818 852.12 43.317 852.496 42.987 852.865 42.663 853.306 42.506 853.843 42.506 854.2 42.506 854.579 42.566 854.97 42.685 855.186 42.751 855.39 42.828 855.592 42.918L856.999 43.546 856.999 37.267 856.288 37.052C855.462 36.803 854.557 36.677 853.6 36.677L853.6 36.677Z",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.499 58.5 875.961 68 870.999 68 866.499 61 861.999 68 856.999 68 863.499 58.5 856.999 49 861.999 49 866.499 56 870.999 49 875.999 49 869.499 58.5ZM855.999 38C855.278 37.782 854.481 37.677 853.599 37.677 851.586 37.677 849.919 38.254 848.595 39.409 847.271 40.564 846.475 42.121 846.204 44.079L845.678 49 842.999 49 842.999 53 845.035 53 843.348 63.691C842.834 67.095 841.674 68.797 839.863 68.797 839.134 68.797 838.513 68.648 837.999 68.351L837.999 72.241C838.336 72.322 838.685 72.406 839.042 72.494 839.399 72.581 839.754 72.626 840.106 72.626 842.173 72.626 843.885 71.873 845.242 70.367 846.599 68.86 847.473 66.764 847.866 64.076L849.594 53 852.999 53 852.999 49 850.236 49 850.783 44.363C850.932 43.431 851.282 42.722 851.837 42.236 852.392 41.75 853.06 41.507 853.843 41.507 854.301 41.507 854.775 41.582 855.261 41.73 855.545 41.817 855.784 41.905 855.999 42.001L855.999 38Z",
    fill: "url(#fill0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunctions);
export default __webpack_public_path__ + "static/media/Functions.26d541ec96de56791614f6bb874de775.svg";
export { ForwardRef as ReactComponent };